import { Theme } from '@mui/material';
/**
 * Styling for ccf-app-space-quick-replies
 * @returns ccf-app-space-quick-replies CSS properties as a JSON object
 * @example ccfQuickRepliesStyles(theme)
*/
const ccfAppHamburgerMenuForAppSpaceStyles = (theme: Theme) => {
  const styles = {
    divider: {
      borderColor: theme.palette.background.paper,
      opacity: 0.6,
    },
    closeButton: {
      display: 'flex',
      justifyContent: 'flex-end',
      fontSize: '0.75rem',
      marginTop: '4px',
      opacity: '0.9',
      backgroundColor: 'transparent',
      border: 'none',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none',
      },
    },
    menuName: {
      color: 'black',
      fontSize: '0.75rem',
      marginLeft: '10px',
      marginRight: 'auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  }
  return styles
}

export default ccfAppHamburgerMenuForAppSpaceStyles